export default [
  {
    id: 'a6ce06f6-33ac-b15a-8be1-6773bcc72852',
    name: 'implementationArea',
    path: 'implementation-area',
    meta: {
      title: '实施区域',
    },
    children: [
      {
        id: 'c7e680ee-cfcc-e3ef-a352-60cee5b985d2',
        name: 'areaManagement',
        path: 'area-management',
        component(resolve) {
          require(['../views/implementationArea/AreaManagement'], resolve)
        },
        meta: {
          title: '实施区域管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            check: {
              id: 1,
              name: 'check',
              desc: '详情',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
    ]
  }
]
